import styled from 'styled-components';

export const ModalContainer = styled.div`
  margin: 20px 0 10px 0;
  h2 {
    color: #096dd9;
    font-weight: 400;
    font-size: 20px;
  }
  .ant-radio-button-wrapper {
    margin-right: 10px;
    margin-bottom: 20px;
    font-weight: 500;
    font-size: 16px;
  }
  .ant-radio-button-wrapper:hover {
    color: #fff;
    background: #1890ff;
    border-color: #1890ff;
  }
  .ant-radio-button-wrapper-checked:not(.ant-radio-button-wrapper-disabled) {
    color: #fff;
    background: #1890ff;
    border-color: #1890ff;
  }
  .info {
    background-color: #faf8f2;
    border: solid 2px #fff1b8;
    padding: 1rem 0.5rem;
    display: block;
    margin-top: 3rem;
    text-align: center;
  }
  p {
    font-size: 14px;
    color: #8c8c8c;
  }
  .searchBtn {
    margin-left: 10px;
  }
  .box-date {
    background-color: #fafafa;
    border: solid 2px #d9d9d9;
    padding: 1rem 0.5rem;
  }
`;

export const Plataforma = styled.div`
  width: 100%;
  background-color: #e3f1fc;
  border-radius: 5px;
  text-transform: uppercase;
  font-family: 'Roboto';
  font-style: normal;
  font-weight: 700;
  font-size: 18px;
  line-height: 24px;
  color: #71717a;
  text-align: center;
  margin: 1rem auto;
  padding: 10px;
`;

export const FiltroTitulo = styled.div`
  font-size: 16px;
  font-family: roboto, serif;
  font-weight: 500;
`;
